import { z } from 'zod';

/**
 * Proposition de maintenance enregistrée (décision 17 : un objet distinct du devis). Les
 * lignes chiffrées et leur base fiscale viennent du barème de l'entreprise choisi
 * (`templateId`) ou de la proposition déjà enregistrée, jamais du corps envoyé : aucune
 * grille de prix n'est livrée par MyEquip.
 */
export const maintenanceProposalBody = z
  .object({
    customerId: z.guid(),
    label: z.string().trim().min(1).max(200),
    templateId: z.guid().nullable().optional(),
    templateVersion: z.number().int().positive().optional(),
    idempotencyKey: z.guid().optional(),
    quantities: z.record(
      z.string().regex(/^[a-zA-Z0-9_-]{1,64}$/),
      z.number().int().min(0).max(1000),
    ),
    discountOneBp: z.number().int().min(0).max(10000).default(0),
    discountTwoBp: z.number().int().min(0).max(10000).default(0),
    /** Les anciens clients sans ces champs gardent leurs deux formules historiques. */
    visitsOne: z.number().int().min(1).max(365).optional(),
    visitsTwo: z.number().int().min(1).max(365).nullable().optional(),
  })
  .strict()
  .refine(
    (v) => Object.values(v.quantities).some((q) => q > 0),
    'Renseignez au moins une quantité.',
  );
